module.exports = __webpack_public_path__ + "static/media/user_icon.e2ffa399.png";